import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { Button } from '@components/main-components/button/Button';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { ModalContext } from '@context/modal';
import { useCreatePost } from '@hooks/useCreatePost';
import { HELP_PATHS } from '@utils/constants';

export const RewardsInfoModal = () => {
  const { closeCancelModal } = ModalContext.useContainer();
  const { onCreatePostClick } = useCreatePost({ onCreate: closeCancelModal });

  const body = (
    <div className="relative mb-3 flex w-full flex-col items-center justify-center gap-y-4">
      <div className="silver-holographic rounded-full p-1">
        <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-black">
          <FontAwesomeIcon icon={faCoins} fontSize="24px" className="text-base50" />
        </div>
      </div>

      <div className="flex w-full flex-col items-center justify-center gap-y-3 text-base800">
        <h2 className="font-title text-title-l font-medium ">Bigger, Better Rewards</h2>

        <p className="flex text-center font-base text-base-l ">
          We&apos;ve increased the rewards for both
          <br />
          artists and curators across Sound.
          <br />
          <br />
          Artists get a share of fees on
          <br />
          every mint, no matter what.
          <br />
          <br />
          Curators now earn up to 20x more in
          <br />
          rewards for every mint driven through
          <br />
          their posts, playlists, and links.
        </p>
      </div>

      <AccessibleLink
        type="external"
        absoluteUri={HELP_PATHS.CuratorRewards}
        className="font-base text-base-l font-semibold underline"
      >
        Learn More
      </AccessibleLink>
    </div>
  );

  return (
    <StandardModal
      body={body}
      closeModal={closeCancelModal}
      callToAction={
        <Button
          variant="primary"
          size="L"
          label="Post to start earning"
          fullWidth
          onClick={onCreatePostClick}
        />
      }
    />
  );
};
